import { BookOpen, Globe, Library, Shield, Users, Zap, type LucideIcon } from "lucide-react";
import { FEATURE_ITEMS } from "./marketing-content";

const FEATURE_ICONS: Record<(typeof FEATURE_ITEMS)[number]["key"], LucideIcon> = {
  catalog: Library,
  circulation: Users,
  "multi-tenant": Shield,
  performance: Zap,
  locale: Globe,
  roles: BookOpen,
};

export function MarketingFeatures() {
  return (
    <section id="features" className="container mx-auto px-4 py-20">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Everything You Need to Manage Your Library
        </h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          Powerful features designed to make library management effortless
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {FEATURE_ITEMS.map((item) => {
          const Icon = FEATURE_ICONS[item.key];
          return (
            <div key={item.key} className="p-6 rounded-lg border bg-card">
              <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <Icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
              <p className="text-muted-foreground">{item.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
